import axios from './config'
import {getType} from '../common/js/util'
import {getApiSign} from '../common/js/apiSign'
import {getToken,setCookie,getSessionToken} from '../common/js/auth'
import {TokenKeys} from '../common/js/variable'
import {getRefreshToken} from '@/api/api'
import Cookies from 'js-cookie'
import {Toast} from 'cube-ui'
import router from '@/router'
// 请求拦截
let toast;
axios.interceptors.request.use(function (config) {
  config.params=config.params?config.params:{};
  if(!config.ifLoading){
    //加载中
    toast=Toast.$create({
      time: 1000,
      mask:false,
      txt: '加载中...',
    }).show();
  }
    let  access_token= Cookies.get(TokenKeys.ACCESS_TOKEN);
    if (config.method === 'get') {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    config.headers["access-token"] = access_token?access_token:'';
    return config;
}, function (error) {
  return Promise.reject(error);
});
// 响应拦截
axios.interceptors.response.use(function (response) {
  response = response.data;
  if (getType(response) == 'string') {
    response = JSON.parse(response);
  }
  if(response.code!=10000){
    if(response.code==10002){
      Cookies.remove(TokenKeys.ACCESS_TOKEN);
      Cookies.remove(TokenKeys.ACCOUNT);
      router.replace('/login');
    }else{
      Toast.$create({
        time: 2000,
        mask:false,
        txt: response.msg,
        type:'error'
      }).show();
    }
  }
  // toast.hide()
  return response;
}, function (error) {
  // toast.hide()
  Toast.$create({
    time: 2000,
    mask:false,
    txt: error.msg,
    type:'error'
  }).show();
  return Promise.reject(error);
});
export default axios



// WEBPACK FOOTER //
// ./src/api/request.js